"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _Heading = require("./Heading.styles");
var _excluded = ["level"];
/**
 * An alias for heading types of the `Text` component.
 *
 * @extends Text
 * @related ['Paragraph']
 * @since 6.0.0
 */
var Heading = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var _theme$theme$NAMESPAC;
  var level = _ref.level,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var defaultFontFamily = (_theme$theme$NAMESPAC = theme === null || theme === void 0 ? void 0 : theme[theme.NAMESPACE].Heading.defaultFontFamily["h" + level]) !== null && _theme$theme$NAMESPAC !== void 0 ? _theme$theme$NAMESPAC : 'sansSerif';
  return /*#__PURE__*/_react.default.createElement(_Heading.StyledHeading, (0, _extends2.default)({
    as: "h" + level,
    fontType: _constants.HEADING_TYPES[level],
    ref: forwardedRef
  }, props, {
    fontFamily: props.fontFamily || defaultFontFamily
  }));
});
exports.Heading = Heading;
Heading.displayName = 'Heading';
Heading.propTypes = process.env.NODE_ENV !== "production" ? {
  /** A string or number representing the heading level */
  level: _propTypes.default.oneOf(['1', '2', '3', '4', '5', '6', 1, 2, 3, 4, 5, 6]).isRequired,
  /** Change the font family of the heading */
  fontFamily: _propTypes.default.oneOf(['serif', 'sansSerif']),
  /**
   * Change the text alignment of the heading.
   *
   * Supports inline media query objects.
   */
  textAlign: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['left', 'center', 'right'])),
  /**
   * Change the text wrapping of the heading.
   *
   * Note: This feature is a part of [CSS Text Level 4](https://www.w3.org/TR/css-text-4/#text-wrap)
   * and not yet supported across all browsers.
   *
   * Supports inline media query objects.
   */
  textWrap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['wrap', 'nowrap', 'balance', 'stable', 'pretty'])),
  /**
   * The styled-components
   * [polymorphic "as"](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any
} : {};